import React, { useState, ElementType } from 'react';
import cx from 'classnames';
import styles from '../style.module.css';
import { AddressActions } from './AddressActions';
import { AddressDesktop } from './AddressDesktop';
import { AddressMobile } from './AddressMobile';
import { RevealAddress } from './RevealAddress';
import { Address } from './types';

const addressWrapper =
  (AddressComponent: ElementType) =>
  ({ address, addressDataValue }: Address) => {
    const [hasSeeAddress, setHasSeeAddress] = useState(false);
    const truncateAddress = cx('transition-ease w-100 dib fl', {
      [styles.truncateText]: !hasSeeAddress,
      [styles.visibleText]: hasSeeAddress,
      'mw-100': hasSeeAddress,
    });
    const handleSeeAddress = () => {
      setHasSeeAddress(!hasSeeAddress);
    };

    return (
      <>
        <div className={truncateAddress}>
          <AddressComponent
            hasSeeAddress={hasSeeAddress}
            address={address}
            addressDataValue={addressDataValue}
          />
          {hasSeeAddress && <AddressActions address={address} />}
        </div>
        <RevealAddress
          hasSeeAddress={hasSeeAddress}
          onClick={handleSeeAddress}
          dataValue={addressDataValue}
        />
      </>
    );
  };

export const SeeAddressDesktop = addressWrapper(AddressDesktop);
export const SeeAddressMobile = addressWrapper(AddressMobile);
